import { useMemo } from "react";
import { TenantQuery } from "v3/services/graphql/generated";

export const usePhoneNumberCountryCodeOnLoad = (
  tenant?: TenantQuery["tenant"] | null
) => {
  const { country, code } = useMemo(() => {
    const { phoneNumberCountryCodesAllowed = [] } =
      tenant?.contactConfig?.shippingAddressConfig || {};

    const { country = "US", code = "+1" } =
      phoneNumberCountryCodesAllowed?.[0] || {};
    return { country, code };
  }, [tenant?.contactConfig?.shippingAddressConfig]);

  return { country, code };
};
